import makeApiRequest from 'src/api/makeApiCall';
import { Config } from '../../latest/src/constants/AppServerConfig';
import { User } from 'src/latest/src/components/UserProfileHeader/types';

const CONFIGURATION_SERVICE = Config?.configurationService;
const USER_SERVICE = Config?.userService;

export const getSuperAdminConfigurationValues = async (
  limit: number,
  offset: number,
) => {
  return await makeApiRequest(
    `${CONFIGURATION_SERVICE}configuration-values?limit=${limit}&offset=${offset}`,
    'GET',
  );
};

export const getSuperAdminConfigurationSearchValue = async (
  configName: string,
) => {
  return await makeApiRequest(
    `${CONFIGURATION_SERVICE}configurations/config-keys/${configName}`,
    'GET',
  );
};

export const updateSuperAdminConfigurationValue = async (
  configName: string,
  configValue: string,
) => {
  const requestBody = {
    value: configValue,
  };

  return await makeApiRequest(
    `${CONFIGURATION_SERVICE}v2/configurations/config-keys/${configName}`,
    'PATCH',
    requestBody,
  );
};

export const getAllSuperAdminUsers = async (
  limit: number,
  offset: number,
  userType?: string,
) => {
  if (userType) {
    return await makeApiRequest(
      `${USER_SERVICE}v1/users/_search?limit=${limit}&offset=${offset}&user_type=${userType}`,
      'GET',
    );
  } else {
    return await makeApiRequest(
      `${USER_SERVICE}v1/users/_search?limit=${limit}&offset=${offset}`,
      'GET',
    );
  }
};

export const blockSuperAdminUser = async (userId: string) => {
  return await makeApiRequest(
    `${USER_SERVICE}v1/users/${userId}/_block`,
    'PATCH',
  );
};

export const unblockSuperAdminUser = async (userId: string) => {
  return await makeApiRequest(
    `${USER_SERVICE}v1/users/${userId}/_unblock`,
    'PATCH',
  );
};

export const updateSuperAdminUserData = async (
  userId: string,
  data: Partial<User>,
) => {
  return await makeApiRequest(
    `${USER_SERVICE}v1/users/${userId}`,
    'PATCH',
    data,
  );
};

export const searchSuperAdminUser = async (
  keyword: string,
  userType?: string,
) => {
  if (userType) {
    return await makeApiRequest(
      `${USER_SERVICE}v1/users/_search?keyword=${keyword}&user_type=${userType}`,
      'GET',
    );
  } else {
    return await makeApiRequest(
      `${USER_SERVICE}v1/users/_search?keyword=${keyword}`,
      'GET',
    );
  }
};

export const getSortedUser = async (
  limit: number,
  offset: number,
  userType: string,
  userStatus: string,
  sortBy: string,
  isProfileRequired: boolean,
  i2iManagedOnly: boolean,
) => {
  return await makeApiRequest(
    `${USER_SERVICE}v1/users/_search?is_profile_required=${isProfileRequired}&limit=${limit}&offset=${offset}&sort_by=${sortBy}&user_status=${userStatus}&user_type=${userType}&i2i_managed_only=${i2iManagedOnly}`,
    'GET',
  );
};

export const deleteSuperAdminUser = async (userId: string) => {
  return await makeApiRequest(`${USER_SERVICE}v1/users/${userId}`, 'DELETE');
};
